import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const userService = {
  user_url: process.env.REACT_APP_USER_API_URL,

  GetApiKeys(refetch) {
    const [apiKeysData, setApiKeysData] = useState([]);
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);

    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(userService.getApiKey())
        .then(res => {
          setApiKeysData(() => res?.data?.apiKeys || []);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch]);

    return {
      apiKeys_loading: status === STATUS.LOADING,
      apiKeys_error: status === STATUS.ERROR,
      apiKeys_data: apiKeysData,
    };
  },

  async updateUser(payload) {
    let res = await Fetch.upload(`${this.user_url}/update-user`, 'PUT', payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updatePassword(payload) {
    let res = await Fetch.patch(`${this.user_url}/update-password`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getToaster() {
    let res = await Fetch.get(`${this.user_url}/get-all-toasters`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async userOnboard(payload) {
    let res = await Fetch.post(`${this.user_url}/onboard-user`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getStripeConfig() {
    let res = await Fetch.get(`${this.user_url}/config`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async createPaymentIntent(payload) {
    let res = await Fetch.post(`${this.user_url}/create-payment-intent`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updateTourCompletion(payload) {
    let res = await Fetch.patch(`${this.user_url}/update-tour-completion`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async generateApiKey(source) {
    let res = await Fetch.post(`${this.user_url}/create-apikey`, { source });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getApiKey() {
    let res = await Fetch.get(`${this.user_url}/get-apikey`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getHoudinyLeadsCredits() {
    let res = await Fetch.get(`${this.user_url}/credits/leads_hub`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getGoogleCalendarAuthUrl() {
    let res = await Fetch.get(`${this.user_url}/google-calendar/connect`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async disconnectGoogleCalendar(selector = {}) {
    const connectedEmail = selector?.connectedEmail;

    if (!connectedEmail) {
      throw new Error('connectedEmail is required to disconnect Google Calendar');
    }

    const params = new URLSearchParams();
    params.set('connectedEmail', String(connectedEmail));
    const query = params.toString();

    let res = await Fetch.patch(`${this.user_url}/google-calendar/disconnect?${query}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getGoogleCalendarAccounts() {
    let res = await Fetch.get(`${this.user_url}/google-calendar/accounts`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default userService;
